import { useContext, useEffect, useRef } from 'preact/hooks'
import { Recovery } from '../index'
import useStepRequest from '../Hooks/useStepRequest'

import styles from './Step.module.css'
import Input from '../Input'
import Button from '../Button'

const PasswordStep = () => {
  const { setError } = useContext(Recovery)
  const { step3 } = useStepRequest()

  const password1 = useRef(null)
  const password2 = useRef(null)

  useEffect(() => {
    password1.current.focus()
  }, [])

  useEffect(() => {
    const enterListener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        finishHandler()
      }
    }
    document.addEventListener('keydown', enterListener)
    return () => {
      document.removeEventListener('keydown', enterListener)
    }
  }, [])

  const finishHandler = () => {
    setError('')
    const pass1 = password1.current.value
    const pass2 = password2.current.value
    if(!pass1 || !pass2){
      setError('Вы оставили поле ввода пустым')
      return;
    }
    if (/[а-яё]/i.test(pass1)) {
      setError('Нельзя использовать кириллицу')
      return
    }
    if (pass1.length < 6 || pass1.length > 30) {
      setError('Пароль не соотвествует требованиям длины')
      return
    }
    if (pass1 !== pass2) {
      setError('Ваши пароли не совпадают')
      return
    }
    const data = new FormData()
    data.append('pass1', pass1)
    data.append('pass2', pass2)
    step3(data)
  }

  return (
    <div className={styles.wrapper}>
      <Input
        inputRef={password1}
        label="Пароль"
        id="password1"
        type='password'
      />
      <Input
        inputRef={password2}
        label="Повтор пароля"
        id="password2"
        type='password'
      />
      <Button name="СОХРАНИТЬ" onClick={finishHandler}/>
      <div className={styles.tip}>
        <p innerHTML="Пароль должен состоять из символов<br/> латинского алфавита (от 6 до 30),<br/>
          содержать заглавные и строчные буквы,<br/> цифры.<br/>
          Чем больше символов, тем безопаснее пароль!" />
      </div>
    </div>
  )
}

export default PasswordStep;